import classNames from 'classnames';
import React from 'react';
import './AppBadge.scss';

interface Props {
  type:
    | 'success'
    | 'warning'
    | 'error'
    | 'neutral'
    | 'success-outline'
    | 'warning-outline'
    | 'error-outline'
    | 'neutral-outline'
    | 'primary'
    | 'primary-light'
    | 'neutral-outline-hover'
    | 'primary-outline-hover'
    | 'ai-hint-text-hover'
    | 'ai-suggest';
  label: string | JSX.Element;
  dataCy?: string;
  onClick?: () => void;
  nowrap?: boolean;
}

export const AppBadge: React.FC<Props> = ({ type = 'success', label = '', dataCy = 'app-badge', onClick, nowrap }) => {
  return (
    <div className="d-flex">
      <div
        className={classNames('app-badge d-flex align-items-center justify-content-center', type, nowrap && 'nowrap')}
        data-cy={dataCy}
        onClick={onClick}
      >
        {label}
      </div>
    </div>
  );
};
